import { render, staticRenderFns } from "./PaSchemeMapReview.vue?vue&type=template&id=6b485f5c&"
import script from "./PaSchemeMapReview.vue?vue&type=script&lang=js&"
export * from "./PaSchemeMapReview.vue?vue&type=script&lang=js&"
import style0 from "./PaSchemeMapReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaSchemeMapReview.vue"
export default component.exports